import { styled } from '@linaria/react';

import { MarketExpanderBetName } from '../MarketExpanderBet/style';

export const AccordionHeader = styled.h2`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px;
  gap: 4px;
  background: var(--ogm-title-bg-color-2);
  border: 1px solid transparent;
  border-radius: 5px;
  transition: border-radius 0.25s ease;
  line-height: 22px;
  font-family: var(--ogm-font-family-1);
  font-size: 16px;
  color: var(--ogm-title-color-1);
  user-select: none;
  cursor: pointer;

  span {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  &[aria-expanded='true'] {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      padding: 12px 20px 11px 20px;

      &:hover {
        border-width: 2px;
        padding: 11px 19px 10px 19px;
      }
    }
  }
`;

export const ExpanderOuterWrapper = styled.div`
  position: relative;
`;

export const ExpanderBestOddsWrapper = styled.div`
  display: grid;
  flex-direction: column;
  justify-content: space-around;
  grid-template-columns: minmax(0, 1fr);
  font-family: var(--ogm-font-family-2);
  width: 100%;
  padding: 16px 15px 0 15px;
  margin: 0 auto;
`;

export const ExpanderBestOddsRow = styled.div`
  width: 930px;
  margin: 0 auto;
  max-width: 100%;

  &:after {
    content: '';
    display: table;
    clear: both;
    height: 1px;
    background-color: var(--oc-line-secondary);
    width: calc(100% - 30px);
    position: absolute;
    left: 15px;
  }
`;

export const ExpanderBestOddsContent = styled.div<{ numberOfColumns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ numberOfColumns }) => numberOfColumns}, 1fr);
  max-width: min(100%, 930px);
  margin: 8px auto;
`;

export const GridToggler = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: var(--ogm-font-family-2);
  font-size: 14px;
  line-height: 17px;
  color: var(--ogm-grid-compare-color);
  background: var(--ogm-grid-compare-bg-color);
  padding: 10px 15px;
  position: relative;
  margin-left: 5px;
  margin-top: 3px;
  cursor: pointer;

  span {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  &[aria-expanded='true'] {
    background: var(--ogm-grid-compare-bg-color);
    &:after {
      transform: rotate(-135deg);
    }
  }

  &:before {
    background: transparent;
  }

  @media (min-width: 1024px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const Pointer = styled.span`
  display: block;
  width: 10px;
  height: 10px;
  transform: translateX(-50%) rotate(45deg);
  transform-origin: center center;
  position: absolute;
  top: calc(100% - 4px);
  left: 50%;
  transition: background 250ms ease;

  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    transition: background 250ms ease;
  }

  ${GridToggler}[aria-expanded='true'] & {
    background: #fff;

    &:before {
      background: var(--ogm-grid-compare-bg-color);
    }
  }

  ${GridToggler}[aria-expanded='false'] & {
    background: transparent;

    :before {
      background: transparent;
    }
  }
`;

export const MarketExpanderSimpleGrid = styled.div<{ numberOfColumns: string }>`
  display: grid;
  grid-template-columns: repeat(${props => props.numberOfColumns}, 1fr);
`;

export const ShowMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 15px;
  margin: 0 auto;
  width: calc(100% - 30px);
  color: var(--oc-primary-blue);
  border-bottom: 1px solid var(--oc-line-secondary);
`;

export const ShowMoreText = styled.button`
  cursor: pointer;
  font-size: 14px;
  @media (min-width: 1024px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      white-space: nowrap;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const UnsupportedMessageWrapper = styled.div`
  padding: 0 15px;
  margin-top: 16px;
`;

export const UnsupportedMessageContent = styled.div`
  background: #edf3fa;
  border: 1px solid #77a6d7;
  border-radius: 5px;
  padding: 8px;
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  color: #0059b5;
`;

export const AccordionWrapper = styled.div`
  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      margin: var(--ogm-grid-market-expander-margin);
    }
  }

  &.not-supported {
    ${AccordionHeader} {
      background: var(--ogm-bg-grey-2);
      border-color: var(--ogm-border-color-1);
      color: black;
    }

    ${GridToggler} {
      color: black;
      background: var(--ogm-white);

      &[aria-expanded='true'] {
        background: black;
        color: var(--ogm-white);

        ${Pointer}:before {
          background: black;
        }
      }
    }

    ${ShowMoreContainer}, ${ShowMoreText} {
      color: #757575;
    }

    ${ShowMoreContainer} {
      border-bottom-color: var(--ogm-border-color-1);
    }

    ${ExpanderBestOddsRow}:after {
      background-color: var(--ogm-border-color-1);
    }

    ${MarketExpanderBetName} {
      color: black;
    }
  }
`;

export const ExpanderContent = styled.div<{ isUnsupported?: boolean }>`
  position: relative;
  width: 100%;
  background-color: #fff;
  border: 1px solid;
  border-color: ${({ isUnsupported }) =>
    isUnsupported ? 'var(--ogm-border-color-1)' : 'var(--ogm-grid-main-border-color)'};
  border-top-color: transparent;
  border-radius: 0 0 5px 5px;
  transition:
    margin-bottom 250ms ease,
    max-height 500ms ease;

  ${AccordionWrapper} [data-enter] & {
    margin-bottom: 5px;
  }
`;

export const MarketHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > span {
    font-family: Public Sans;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0px;
  }
`;
